var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { observable, action, computed } from 'mobx';
import * as monaco from 'monaco-editor';
import { serializable, identifier, map, createSimpleSchema, object, primitive } from 'serializr';
export default class EditorStore {
    constructor(name, isActive = false) {
        this.name = name;
        this.files = new Map();
        this.isActive = isActive;
        this.files.set(EditorStore.MAIN, {
            uri: EditorStore.MAIN,
            language: 'greycat',
            content: 'var hello = "Hello World!";\n\nsayHi();',
            isOpen: true,
            isSelected: true,
        });
        this.files.set(EditorStore.EXTENSIONS, {
            uri: EditorStore.EXTENSIONS,
            language: 'typescript',
            content: "export function sayHi(ctx: g.Context) {\n  studio.console.log(ctx.get('hello'));\n}",
            isOpen: true,
            isSelected: false,
        });
    }
    select(uri) {
        this.files.forEach((f) => {
            if (f.uri !== uri) {
                f.isSelected = false;
            }
            else {
                f.isSelected = true;
            }
        });
    }
    open(uri) {
        const file = this.files.get(uri);
        if (file) {
            file.isOpen = true;
            this.select(uri);
        }
    }
    close(uri) {
        const file = this.files.get(uri);
        if (file) {
            file.isOpen = false;
            file.isSelected = false;
        }
    }
    setState(uri, state) {
        const file = this.files.get(uri);
        if (file) {
            file.state = state;
        }
    }
    setContent(uri, content) {
        const file = this.files.get(uri);
        if (file) {
            file.content = content;
        }
    }
    get selected() {
        const file = [...this.files.values()].find((f) => f.isSelected);
        if (!file) {
            this.files.get(EditorStore.MAIN).isSelected = true;
            return this.files.get(EditorStore.MAIN);
        }
        return file;
    }
    get opened() {
        return [...this.files.values()]
            .filter(({ isOpen }) => Boolean(isOpen))
            .sort((a) => {
            // be sure to have 'main.gcl' always first in the tab list
            return a.uri === EditorStore.MAIN ? 0 : 1;
        });
    }
}
EditorStore.MAIN = 'main.gcl';
EditorStore.EXTENSIONS = 'extensions.ts';
__decorate([
    observable,
    serializable(identifier()),
    __metadata("design:type", String)
], EditorStore.prototype, "name", void 0);
__decorate([
    observable,
    serializable(map(object(createSimpleSchema({
        uri: primitive(),
        language: primitive(),
        content: primitive(),
        isOpen: primitive(),
        isSelected: primitive(),
    })))),
    __metadata("design:type", typeof (_a = typeof Map !== "undefined" && Map) === "function" ? _a : Object)
], EditorStore.prototype, "files", void 0);
__decorate([
    observable,
    serializable,
    __metadata("design:type", Boolean)
], EditorStore.prototype, "isActive", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EditorStore.prototype, "select", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EditorStore.prototype, "open", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], EditorStore.prototype, "close", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, typeof (_c = typeof monaco !== "undefined" && (_b = monaco.editor) !== void 0 && _b.ICodeEditorViewState) === "function" ? _c : Object]),
    __metadata("design:returntype", void 0)
], EditorStore.prototype, "setState", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], EditorStore.prototype, "setContent", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], EditorStore.prototype, "selected", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], EditorStore.prototype, "opened", null);
